import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useContext } from 'react';
import clsx from 'clsx';
import { isDef, addUnit } from '../utils';
import { isNumeric } from '../utils/validate/number';
import ConfigProviderContext from '../config-provider/ConfigProviderContext';

var Badge = function Badge(props) {
  var content = props.content,
      max = props.max,
      dot = props.dot,
      showZero = props.showZero,
      _props$tag = props.tag,
      tag = _props$tag === void 0 ? 'div' : _props$tag;

  var _useContext = useContext(ConfigProviderContext),
      prefixCls = _useContext.prefixCls,
      createNamespace = _useContext.createNamespace;

  var _createNamespace = createNamespace('badge', prefixCls),
      _createNamespace2 = _slicedToArray(_createNamespace, 1),
      bem = _createNamespace2[0];

  var TagElement = tag;

  var hasContent = function hasContent() {
    if (props.content) {
      return true;
    }

    return isDef(content) && content !== '' && (showZero || +content !== 0);
  };

  var renderContent = function renderContent() {
    if (!dot && hasContent()) {
      if (isDef(max) && isNumeric(content === null || content === void 0 ? void 0 : content.toString()) && +content > max) {
        return "".concat(max, "+");
      }

      return content;
    }

    return null;
  };

  var renderBadge = function renderBadge() {
    if (hasContent() || props.dot) {
      var style = {
        background: props.color
      };

      if (props.offset) {
        var _props$offset = _slicedToArray(props.offset, 2),
            x = _props$offset[0],
            y = _props$offset[1];

        if (props.children) {
          style.top = addUnit(y);
          style.right = addUnit(x);
        } else {
          style.marginTop = addUnit(y);
          style.marginLeft = addUnit(x);
        }
      }

      if (!props.children) {
        style = _objectSpread(_objectSpread({}, props.style), style);
      }

      return /*#__PURE__*/React.createElement("div", {
        className: clsx(_defineProperty({}, props.className, props.className && !props.children), bem({
          dot: props.dot,
          fixed: !!props.children
        })),
        style: style
      }, renderContent());
    }

    return null;
  };

  if (props.children) {
    return /*#__PURE__*/React.createElement(TagElement, {
      className: clsx(bem('wrapper'), props.className),
      style: props.style,
      onClick: props.onClick,
      onTouchStart: props.onTouchStart
    }, props.children, renderBadge());
  }

  return renderBadge();
};

Badge.defaultProps = {
  tag: 'div',
  showZero: true
};
export default Badge;